import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ReferensiPage from "@/pages/ReferensiPage";
import AboutPage from "@/pages/AboutPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A1628] text-white overflow-x-hidden">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/referensi" element={<ReferensiPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
